import Request from '../Request'
import constants from '../../constants/constant'

const OrbitReportService = {
  async getReportContext(clientId, params = {}) {
	return Request.get(`/api/clients/${clientId}/orbit/report-context`, params, false, true)
  },

  async createReportDraft(clientId, payload = {}) {
	return Request.post(`/api/clients/${clientId}/orbit/report-drafts`, payload)
  },

  async updateReportDraft(clientId, payload = {}) {
	return Request.post(`/api/clients/${clientId}/orbit/report-drafts/update`, payload)
  },

  async reviewReportDraft(clientId, payload = {}) {
	return Request.post(`/api/clients/${clientId}/orbit/report-drafts/review`, payload)
  },

  async getReportArtifact(clientId, artifactId, params = {}) {
	return Request.get(`/api/clients/${clientId}/orbit/report-artifacts/${artifactId}`, params, false, true)
  },

  async saveReportDraft(clientId, payload = {}) {
	return Request.post(`/api/clients/${clientId}/orbit/report-drafts/save`, payload)
  },

  async generateReportArtifact(clientId, artifactId, payload = {}) {
  return Request.post(`/api/clients/${clientId}/orbit/report-artifacts/${artifactId}/generate`, payload)
  },

  async getReportArtifactStatus(clientId, artifactId, params = {}) {
  return Request.get(`/api/clients/${clientId}/orbit/report-artifacts/${artifactId}/status`, params, false, true)
  },

  getReportArtifactDownloadUrl(clientId, artifactId) {
  const accessToken = localStorage.getItem('access_token')
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const query = new URLSearchParams({
    _access_token: accessToken || '',
    timezone,
  }).toString()
  return `${constants.BACKEND_DOMAIN}/api/clients/${clientId}/orbit/report-artifacts/${artifactId}/download?${query}`
  },
}

export default OrbitReportService

